/**
 * Will be `true` if the code is running in a visual regression test (go/jira-vr for details).
 *
 * If you're trying to fix animation-related test flakiness, this util is **NOT** what you want.
 * Instead, make sure your code supports the `prefers-reduced-motion` user preference, which is
 * automatically enabled for VR tests.
 *
 * To support `prefers-reduced-motion`, you can either:
 * - Make your animations CSS-driven (in which case global CSS overrides will handle it for you).
 * - Make use of the Atlaskit motion `useIsReducedMotion()` hook.
 */
export const isVisualRegressionTest: boolean =
	!__SERVER__ && window?.location
		? Boolean(new URL(window.location.href).searchParams.get('eyes-storybook'))
		: false;
